import { render, staticRenderFns } from "./IBANValidation.vue?vue&type=template&id=3ed498ca&scoped=true"
import script from "./IBANValidation.vue?vue&type=script&lang=ts"
export * from "./IBANValidation.vue?vue&type=script&lang=ts"
import style0 from "./IBANValidation.vue?vue&type=style&index=0&id=3ed498ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed498ca",
  null
  
)

export default component.exports